<template>
<div id="loadingBoxAddress">
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item
      label="地址类型:"
      prop="addressType"
    >
      <!-- <el-select
        multiple
        :disabled="!this.editData.id?false:true"
        v-model="ruleForm.addressType"
        placeholder="请选择地址类型"
        style="width: 100%">
        <el-option
          v-for="(item, index) in stateList"
          :label="item.label"
          :value="item.value"
          :key="index"
        />
      </el-select> -->
      <el-checkbox-group v-model="ruleForm.addressType" :disabled="!this.editData.id?false:true">
        <el-checkbox  :label="item.value" :key="index"  v-for="(item, index) in stateList">{{item.label}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item
      label="所在地区:"
      prop="areaList"
    >
      <el-cascader
        v-model="ruleForm.areaList"
        :options="options"
        :props="props"
      ></el-cascader>
    </el-form-item>
    <el-form-item
      label="详细地址:"
      prop="detailAddress"
    >
      <el-input v-model="ruleForm.detailAddress"></el-input>
    </el-form-item>
    <el-form-item
      label="邮政编码:"
      prop="zipCode"
    >
      <el-input v-model="ruleForm.zipCode"></el-input>
    </el-form-item>
    <el-form-item
      label="联系人:"
      prop="linkMan"
    >
      <el-input v-model="ruleForm.linkMan"></el-input>
    </el-form-item>
    <el-form-item
      label="联系方式"
      prop="linkPhone">
      <el-input maxlength="11" v-model="ruleForm.linkPhone"></el-input>
    </el-form-item>

    <el-form-item
      style="text-align: center"
      label-width="0px"
    >
      <el-button
        type="primary"
         :loading="submitBtn"
        @click="submitForm"
      >确 定</el-button>
    </el-form-item>
  </el-form>
</div>
  
</template>

<script>
export default {
  props: {
    editData:{
      type: Object,
    }
  },
  data () {
    return {
      submitBtn:false,
      dialogVisible: false,
      titleDialog: "",
      ruleForm: {
        addressType: [],
        areaList: '',
        detailAddress: '',
        zipCode: '',
        linkMan: '',
        linkPhone: ''
      },
      rules: {
        addressType: [{required: true, message: "请选择地址类型", trigger: "change" }],
        areaList: [{ required: true, message: "请选择所在地区", trigger: "change" }],
        detailAddress: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        linkMan: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        linkPhone: [{ required: true, message: "请输入联系方式", trigger: "blur" }, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号格式错误",
          trigger: "blur",
        },],
      },
      // 状态列表
      stateList: [
        {
          label: "收票地址",
          value: "00",
        },
        {
          label: "收货地址",
          value: "01",
        },
        {
          label: "开票地址",
          value: "02",
        },
        {
          label: "其他",
          value: "03",
        },
      ],
      //
      options: [],
      props: {
        value: "areaCode",
        label: "areaName",
        children: "childAreaInfo",
      },
    }
  },
  methods: {
    // 弹框确定
    submitForm () {
      // console.log(this.options);
      // console.log(this.ruleForm);
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.submitBtn=true
          // let formData = new FormData();
          // formData.append("sign", '1'); // 标识数据来源为客商平台
          // formData.append("id", this.ruleForm.id ? this.ruleForm.id : "");
          // if (!this.demoBoolean) {
          //   formData.append("companyCode", JSON.parse(localStorage.getItem("companyInfo")).bspCompanyCode || ""); //企业U代码
          //   formData.append("companyName", JSON.parse(localStorage.getItem("companyInfo")).fullName || ""); //企业名称
          // } else {
          //   formData.append("companyCode", ""); //企业U代码
          //   formData.append("companyName", ""); //企业名称
          // }
          // formData.append("linkMan", this.ruleForm.linkMan); //联系人
          // formData.append("detailAddress", this.ruleForm.detailAddress); //地址
          // formData.append("zipCode", this.ruleForm.zipCode ? this.ruleForm.zipCode : ""); //邮编
          // formData.append("linkPhone", this.ruleForm.linkPhone); //联系电话
          // formData.append("phonenum", ""); //固定电话
          // formData.append("defaultrec", "00"); //是否默认收票人(01:默认 00:非默认)
          // formData.append("addressType", this.ruleForm.addressType.join(',')); //地址类型 00 收票地址，01收货地址，02开票地址，03其他
          // formData.append("mailbox", ""); //邮箱
          // formData.append("facsimile", ""); //传真
          // formData.append("receiptProvinceCode", this.ruleForm.areaList[0]); //省份代码
          // formData.append("receiptCityCode", this.ruleForm.areaList[1]); //城市代码
          // formData.append("receiptTownCode", this.ruleForm.areaList[2]); //地区代码
          // formData.append("userCode", ''); //发票使用人code
          // formData.append("userName",'');//发票使用人name
          // formData.append("invoiceCompanyCode", ''); //开票单位code
          // formData.append("invoiceCompanyName", ''); //开票单位name
          // formData.append("createTime", ''); //创建时间
          // formData.append("updateTime",''); //修改时间



        this.ruleForm.bspCompanyCode=JSON.parse(localStorage.getItem('companyInfo')).bspCompanyCode
        this.ruleForm.addressType=this.ruleForm.addressType.join(',')
        this.ruleForm.provinceCode=this.ruleForm.areaList[0]
        this.ruleForm.cityCode=this.ruleForm.areaList[1]
        this.ruleForm.areaCode=this.ruleForm.areaList[2]
        this.ruleForm.contactSeqId=''
        this.options.forEach(item=>{
            if(this.ruleForm.provinceCode==item.areaCode){
                this.ruleForm.province=item.areaName
            }
            item.childAreaInfo.forEach(item1=>{
              if(this.ruleForm.cityCode==item1.areaCode){
                this.ruleForm.city=item1.areaName
              }
              item1.childAreaInfo.forEach(item2=>{
                if(this.ruleForm.areaCode==item2.areaCode){
                  this.ruleForm.area=item2.areaName
                }
              })
            })
        })
          // let axios = ''
          // if (this.demoBoolean) {
          //   axios = this.$api.client.postInvoiceSaveReceipt(this.ruleForm)
          // } else {
          //   axios = this.$api.client.postInvoiceSaveReceiptNoLogin(this.ruleForm)
          // }
         this.$api.client.postAddressSaveAddress([this.ruleForm]).then((res) => {
            this.submitBtn=false
            if (res.status==200) {
              this.$emit('addressDialogVisible', false)
              this.$message.success(res.msg);
              this.$refs["ruleForm"].resetFields();
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err)=>{
              this.submitBtn=false
            })
        } else {
          this.$message.warning('请完善必填信息!')
          return false
        }
      });
    },
  },
  created () {

    //地址，地区
    this.$api.client.postResumegetAreaList().then((res) => {
      if(res.status=='200'){
        this.options = res.data;
        if(this.editData.id){
            //数据加载时整个页面显示loading
            const loading = this.$loading({
              //lock的修改符--默认是false
              lock: true,
              //显示在加载图标下方的加载文案
              text: "Loading",
              //自定义加载图标类名(在elementUI 文档查找)
              spinner: "el-icon-loading",
              //(可以自己定义)遮罩层颜色
              background: "rgba(255, 255, 255, .7)",
              //loadin覆盖的dom元素节点(整个页面的话'#body' 表格的话'#table'等等 )
              target: document.querySelector("#loadingBoxAddress"),
            });
            if(typeof this.editData.addressTypeCode=='string'){
              this.editData.addressType=[this.editData.addressTypeCode]
            }
            // this.editData.addressType= this.editData.addressTypeCode
            this.editData.areaList = [this.editData.provinceCode, this.editData.cityCode, this.editData.areaCode];
            this.ruleForm = { ...this.editData };
            loading.close();
        }
      }else{
        this.$message.error(res.message)
      }
     
    });
  }
}
</script>

<style scoped>
</style>